// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"SpendingPage__buttonWrapper__ohwj1","topButtonWrapper":"SpendingPage__topButtonWrapper__g1GE-"};